import React, { useEffect, useState } from "react";

export function InvoiceNumberInput({
  value,
  onChange,
  className,
  maxLength = 20, // ajuste se quiser (ex.: 3 para 001/002/003)
  ...rest
}) {
  const [text, setText] = useState("");

  // sincroniza quando o value externo mudar
  useEffect(() => {
    if (value === "" || value == null) {
      setText("");
      return;
    }

    const digitsOnly = String(value).replace(/\D/g, "").slice(0, maxLength);
    setText((prev) => (prev === digitsOnly ? prev : digitsOnly));
  }, [value, maxLength]);

  const handleChange = (e) => {
    const digitsOnly = e.target.value.replace(/\D/g, "").slice(0, maxLength);

    setText(digitsOnly);
    onChange && onChange(digitsOnly); // string, preserva zeros à esquerda
  };

  return (
    <input
      type="text"
      inputMode="numeric"
      autoComplete="off"
      className={className}
      value={text}
      onChange={handleChange}
      {...rest}
    />
  );
}
